import { useState } from "react";
import { editorialTabs } from "@/mocks/events";

const cards: Record<string, Array<{ icon: string; title: string; desc: string }>> = {
  all: [
    { icon: "ri-stack-line", title: "脉络式还原", desc: "抛弃碎片化八卦，用结构化专题把一次事件的每个转折都串联成可回看的完整脉络。" },
    { icon: "ri-history-line", title: "节点不遗漏", desc: "从发酵到落地，关键声明、关键人物、关键时间点都一一记录，前后照应一目了然。" },
    { icon: "ri-vip-diamond-line", title: "结案即归档", desc: "事件尘埃落定后自动转为复盘档案长期保留，随时可回看当初的反转全程。" },
  ],
  hot: [
    { icon: "ri-focus-3-line", title: "热度分级标注", desc: "每个瓜点按发酵强度分级，顶置正在爆发的现场，避免错过最重要的那一口。" },
    { icon: "ri-bar-chart-line", title: "实时热度曲线", desc: "结合讨论量与传播速度，帮助你判断事件是昙花一现还是持续升温的长期话题。" },
    { icon: "ri-fire-line", title: "爆点第一时间捕捉", desc: "聚合热搜与社区动向，在事件冲向高点前就为你亮起预告，抢占先机。" },
  ],
  latest: [
    { icon: "ri-refresh-line", title: "进展实时同步", desc: "重要事件每一次反转与回应，我们都在半小时内完成核实并更新到对应节点。" },
    { icon: "ri-flag-2-line", title: "来源时间戳", desc: "每个进展都标注信源与更新时间，前后口径对不上的地方会明确标出并持续追证。" },
    { icon: "ri-alarm-line", title: "重要更新提醒", desc: "你在订阅中关注的事件若迎来关键转折，将第一时间通过邮件推送给你。" },
  ],
};

export default function Credibility() {
  const [active, setActive] = useState("all");

  return (
    <section id="why" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <p className="inline-flex items-center gap-2 text-sm font-bold text-primary-600">
            <span className="h-px w-6 bg-primary-500" />
            为什么选择爆炸瓜
            <span className="h-px w-6 bg-primary-500" />
          </p>
          <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-4xl">
            追瓜，也可以很严谨
          </h2>
          <p className="mt-3 text-sm text-foreground-600 md:text-base">
            我们不追流量带节奏，只做一件事：把正在发生和已经发生的事件，讲得清楚、讲得完整。
          </p>
        </div>

        {/* segmented tabs */}
        <div className="mt-8 flex justify-center">
          <div className="inline-flex items-center gap-1 rounded-full bg-secondary-100 p-1">
            {editorialTabs.map((t) => (
              <button
                key={t.key}
                onClick={() => setActive(t.key)}
                className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-medium transition-colors md:px-5 ${
                  active === t.key
                    ? "bg-background-50 text-foreground-950 shadow-sm"
                    : "text-foreground-600 hover:text-foreground-900"
                }`}
              >
                {t.label}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3">
          {cards[active].map((c) => (
            <div
              key={c.title}
              className="rounded-2xl border border-background-200 bg-background-100 p-6 transition-colors hover:border-primary-200"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <i className={`${c.icon} text-xl`} />
              </span>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{c.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{c.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}